/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class GroupsGrid extends NoboxEntityGrid<GroupsRow, any> {
        protected getColumnsKey() { return GroupsColumns.columnsKey; }
        protected getDialogType() { return GroupsDialog; }
        protected getIdProperty() { return GroupsRow.idProperty; }
        protected getInsertPermission() { return GroupsRow.insertPermission; }
        protected getLocalTextPrefix() { return GroupsRow.localTextPrefix; }
        protected getService() { return GroupsService.baseUrl; }

        private defaultSetting: Serenity.PersistedGridSettings;

        private WARNING_THRESHOLD = 5;
        private ALERT_THRESHOLD = 3;
        private TIME_LIMIT = 10;
        private timePassed = 0;
        private timeLeft = this.TIME_LIMIT;
        private timerInterval = null;
        private refreshInterval = null;
        private timerActive = false;

        private COLOR_CODES = {
            info: {
                color: "text-green"
            },
            warning: {
                color: "text-orange",
                threshold: this.WARNING_THRESHOLD
            },
            alert: {
                color: "text-red",
                threshold: this.ALERT_THRESHOLD
            }
        };

        protected getSlickOptions(): Slick.GridOptions {
            var opt = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            opt.selectedCellCssClass = "slick-row-selected";
            opt.enableCellNavigation = true;
            return opt;
        }

        protected getPersistanceStorage(): Serenity.SettingStorage {

            return window.localStorage;
        }
        protected updateInterface() {
            this.defaultSetting = this.getCurrentSettings();
            super.updateInterface();
        }

        calculateTimeFraction() {
            const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
            return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
        }

        onTimesUp(e) {
            clearInterval(this.timerInterval);
            if (this.refreshInterval != null) {
                clearInterval(this.refreshInterval);
            }
            e.html("<i class=\"fa fa-stopwatch text-blue\"></i>");
            this.WARNING_THRESHOLD = 5;
            this.ALERT_THRESHOLD = 3;
            this.TIME_LIMIT = 10;
            this.timePassed = 0;
            this.timeLeft = 10;
            this.timerInterval = null;
            this.refreshInterval = null;
            this.timerActive = false;
        }

        startTimer(e) {
            this.timerActive = true;
            var $this = this;
            this.refreshInterval = setInterval(() => {
                this.refresh();
            }, 10000);
            e.removeClass(this.COLOR_CODES.info.color);
            e.removeClass(this.COLOR_CODES.alert.color);
            e.removeClass(this.COLOR_CODES.warning.color);
            e.addClass(this.COLOR_CODES.info.color);
            this.timerInterval = setInterval(() => {
                this.timePassed = this.timePassed += 1;
                this.timeLeft = this.TIME_LIMIT - this.timePassed;
                e.text(this.formatTime(
                    this.timeLeft
                ));
                this.setRemainingPathColor(this.timeLeft, e);

                if (this.timeLeft === 0) {
                    this.WARNING_THRESHOLD = 5;
                    this.ALERT_THRESHOLD = 3;
                    this.TIME_LIMIT = 10;
                    this.timePassed = 0;
                    this.timeLeft = 10;
                }
            }, 1000);
        }
        setRemainingPathColor(timeLeft, e) {
            const { alert, warning, info } = this.COLOR_CODES;
            if (timeLeft <= alert.threshold) {
                e
                    .removeClass(warning.color);
                e
                    .addClass(alert.color);
            } else if (timeLeft <= warning.threshold) {
                e
                    .removeClass(info.color);
                e
                    .addClass(warning.color);
            } else if (timeLeft >= warning.threshold) {
                e
                    .removeClass(alert.color);
                e
                    .addClass(info.color);
            }
        }
        formatTime(time) {
            const minutes = Math.floor(time / 60);
            let seconds = time % 60 as any;

            if (seconds < 10) {
                seconds = `0${seconds}`;
            }
            if (seconds == 0) {
                seconds = `...`;
            }

            return `${seconds}`;
        }

        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();

            buttons.push({
                icon: "fa-undo-alt text-blue",
                hint: "Restore to default grid settings",
                onClick: () => {
                    Q.confirm("Are you sure restore grid settings to default?", () => {
                        this.restoreSettings(this.defaultSetting, this.gridPersistanceFlags())
                        localStorage.removeItem(this.getPersistanceKey());
                        Q.notifySuccess("Restored setting grid to default");
                    });
                }
            });
            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                grid: this,
                service: GroupsService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            buttons.push(Serenity.Extensions.PdfExportHelper.createToolButton({
                grid: this,
                tableOptions: {
                    theme: "grid",
                },
                onViewSubmit: () => this.onViewSubmit()
            }));

            buttons.push({
                icon: "fa-stopwatch text-blue",
                separator: true,
                cssClass: "btn-autorefresh",
                hint: "Auto Refresh in 10 seconds",
                onClick: function (e) {
                    if (!$this.timerActive) {
                        if ($(e.currentTarget).hasClass("tool-button")) {
                            $(e.currentTarget).find(".button-inner").text("10");
                            $this.startTimer($(e.currentTarget).find(".button-inner"));
                        } else {
                            $(e.currentTarget).parents(".tool-button").find(".button-inner").text("10")
                            $this.startTimer($(e.currentTarget).parents(".tool-button").find(".button-inner"));
                        }
                    } else {
                        if ($(e.currentTarget).hasClass("tool-button")) {
                            $this.onTimesUp($(e.currentTarget).find(".button-inner"));

                        } else {
                            $this.onTimesUp($(e.currentTarget).parents(".tool-button").find(".button-inner"));
                        }
                    }
                }
            });
            return buttons;
        }


        constructor(container: JQuery) {
            super(container);

            this.element.find(".grid-title").css("justify-content", "space-between");
            this.element.find('.grid-title').append(`<a style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:5px;" class="btn btn-icon btn-sm p-0 ml-1 float-right" target="_blank" href="${$('#GridDiv').attr('help-url')}">
                <div class="tool-button icon-tool-button" title="Help">
                    <div class="button-outer">
                        <span class="button-inner green">
                            <i class="fa fa-question-circle text-blue"></i>
                        </span>
                    </div>
                </div>
            </a>`);
        }
    }
}